import $ from 'jquery';

const subMenu = () => {
    const $desktopNav = $('.c-desktop-menu li');
    let winWidth = $(window).width();

    const initSubMenu = () => {
        $desktopNav.each(function () {
            const $el = $(this);

            if ($el.find('.child-menu').length > 0) {
                const $subMenu = $el.find('.child-menu');
                const subMenuWidth = $subMenu.outerWidth() / 2;

                $subMenu.css({ 'margin-left': `-${subMenuWidth}px` })
                    .find('span.arrow').css({ left: '50%', right: 'auto' });

                // if out of left screen, move it
                if ($subMenu.offset().left < 0) {
                    $subMenu.css({ 'margin-left': `-${$el.outerWidth() / 2}px` })
                        .find('span.arrow').css('left', `${$el.outerWidth() / 2}px`);
                }

                // if out of right, move it
                if (winWidth <= $subMenu.outerWidth() + $subMenu.offset().left) {
                    $subMenu.css({ 'margin-left': `-${subMenuWidth + ($el.outerWidth() / 2)}px` });
                    const $span = $subMenu.find('span.arrow');
                    $span.css({
                        left: 'auto',
                        right: `${($el.outerWidth() / 2) - ($span.outerWidth() / 2)}px`
                    });
                }
            }
        });
    };

    $desktopNav.hover(
        function () {
            $(this).find('.child-menu').addClass('active');
        },
        function () {
            $(this).find('.child-menu').removeClass('active');
        }
    );

    $desktopNav.find('.child-menu').prepend('<span class="arrow"></span>');

    initSubMenu();

    $(window).resize(() => {
        if ($(window).width() !== winWidth) {
            winWidth = $(window).width();
            initSubMenu();
        }
    });
};

// doc ready
$(() => {
    subMenu();
});



// WEBPACK FOOTER //
// ./src/components/desktop-header/desktop-menu/c-desktop-menu.js